import React from 'react'
import { Route } from 'react-router-dom'
import Account from './Account'
import Report from './Report'
import Trade from './Trade'

const routers = [
  <Route key="/account" path="*/account" exact component={Account} />, // 账户中心
  <Route key="/report" path="*/report" component={Report} />, // 报告中心
  <Route key="/trade" path="*/trade" component={Trade} />, //交易明细
]

export default routers
